module.exports = __webpack_public_path__ + "static/hab_research_5-1f903c75582fdea3e4fc26afacc04c5b.png";